import { IVehicle } from "@interfaces/IVehicle";
import { TranslationService } from "@services/translation.service";
import { ITemperatureProfile } from "@temperature/_models/temperature/ITemperatureProfile";
import { TemperatureService } from "@temperature/_services/temperature.service";
import { ZoneService } from "@temperature/_services/zone.service";
import { IZone } from "@temperature/_models/temperature/ITemperatureZone";
import { ZoneStatus } from "@temperature/_enums/temperature/ZoneStatus.enum";
import * as angular from "angular";
import "./temperatureProbes.scss";
import { VehicleService } from "@services/vehicle.service";
import { lastValueFrom } from "rxjs";

class TemperatureProbesComponentController implements angular.IComponentController {
    selectedVehicle: IVehicle;

    zones: IZone[];
    profileList: ITemperatureProfile[] = [];
    selectedProfile: string;
    onProbesValid: (args: { message: string }) => void;

    errorMessage: string;

    static $inject = ["$mdDialog", "temperatureService", "translationService", "zoneService", "vehicleService"];

    constructor(
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly temperatureService: TemperatureService,
        private readonly translationService: TranslationService,
        private readonly zoneService: ZoneService,
        private readonly vehicleService: VehicleService,
    ) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["selectedVehicle"]) {
            this.loadTemperatureProfiles();
            this.sortProbes();
            this.loadTemperatureZones();
            this.checkProbeValidity();
        }
    }



    onModelUpdated(currentIndex?: number) {
        this.checkProbeValidity(currentIndex);
    }

    openEditTempProfilesDialog($event: MouseEvent) {

        const controller = ($mdDialog) => {

            return {
                hide: () => { $mdDialog.hide(); },
                vehicle: this.selectedVehicle,
                zones: this.zones
            }
        };

        controller.$inject = ["$mdDialog"];

        const dialogOptions: angular.material.IDialogOptions = {
            targetEvent: $event,
            escapeToClose: true,
            clickOutsideToClose: true,
            template: require("./temperatureProfilesZonesEdit.dialog.html"), // Use scope
            controller: controller,
            controllerAs: "$ctrl"
        };

        this.$mdDialog.show(dialogOptions).then(() => {
            this.loadTemperatureProfiles();
            this.loadTemperatureZones();
            this.vehicleService.getVehicleProbes(this.selectedVehicle);
        });

    }

    //--

    private checkDuplicateName(currentIndex?: number) {
        for (var i = 0; i < this.selectedVehicle.probes.length; i++) {
            if (i != currentIndex && this.selectedVehicle.probes[currentIndex].Name == this.selectedVehicle.probes[i].Name) {
                this.errorMessage = this.translationService.t('temperatureProbes.nameInUse');
            }
        }
    }

    private loadTemperatureProfiles() {
        this.temperatureService.getTemperatureProfiles()
            .then(profiles => {
                this.profileList = profiles;
            });
    }

    private sortProbes(): void {
        this.selectedVehicle?.probes.sort((probe1, probe2) => probe1.Position - probe2.Position);
    }

    private checkProbeValidity(currentIndex?: number) {
        this.errorMessage = '';

        this.selectedVehicle?.probes.forEach(probe => {

            if (!probe.TemperatureProfileId) {
                this.errorMessage = this.translationService.t('temperatureProbes.profileRequired');
            }

            if (!probe.Name) {
                this.errorMessage = this.translationService.t('temperatureProbes.nameRequired');
            }
        });

        if (currentIndex >= 0) {
            this.checkDuplicateName(currentIndex);
        }

        if (this.onProbesValid) {
            this.onProbesValid({ message: this.errorMessage });
        }
    }

    private loadTemperatureZones() {

        if (this.selectedVehicle?.Id) {
            return lastValueFrom(this.zoneService.getZones({ VehicleId: this.selectedVehicle.Id, Status: ZoneStatus.Active, invalidateCache: false })).then(zones => {
                this.zones = zones;

                this.zoneService.mapProbesToZone(this.zones, this.selectedVehicle.probes);
            })
        }

    }
}

export class TemperatureProbesComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            selectedVehicle: "<",
            onProbesValid: "&",
        };

        this.controller = TemperatureProbesComponentController;
        this.template = require("./temperatureProbes.html");
    }
}
